module.exports = __webpack_public_path__ + "img/Canada.7e3b7919.svg";